const AppModalFilePreview = ({
  previewModal,
  closePreview
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
      onClick={closePreview}
    >
      {/* Modal Content */}
      <div
        style={{
          position: 'relative',
          maxWidth: '90vw',
          maxHeight: '90vh',
          backgroundColor: 'white',
          borderRadius: '8px',
          overflow: 'hidden'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px 20px',
            backgroundColor: '#f0f2f5',
            borderBottom: '1px solid #d1d7db'
          }}
        >
          <div style={{ fontSize: '16px', fontWeight: '500', color: '#111b21' }}>
            {previewModal.type === 'image' && 'Image Preview'}
            {previewModal.type === 'document' && (previewModal.fileName || 'Document Preview')}
          </div>
          
          <div style={{ display: 'flex', gap: '8px' }}>
            {/* Close Button */}
            <button
              onClick={closePreview}
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                borderRadius: '50%',
                width: '40px',
                height: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.05)'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
              title="Close"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="#667781">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
          </div>
        </div>
        
        {/* Content */}
        <div
          style={{
            maxHeight: 'calc(90vh - 70px)',
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: '#f0f2f5'
          }}
        >
          {previewModal.type === 'image' && (
            <img
              src={previewModal.url}
              alt="Image Preview"
              style={{
                maxWidth: '100%',
                maxHeight: 'calc(90vh - 70px)',
                objectFit: 'contain'
              }}
            />
          )}
          {previewModal.type === 'docs' && (
            <iframe
              src={`https://docs.google.com/gview?url=${previewModal.url}&embedded=true`}
              style={{
                width: '80vw',
                height: 'calc(90vh - 70px)',
                border: 'none'
              }}
              title="Document Preview"
            />
          )}
          {previewModal.type === 'pdf' && (
            <iframe
              src={`${previewModal.url}`}
              style={{
                width: '80vw',
                height: 'calc(90vh - 70px)',
                border: 'none'
              }}
              title="PDF Preview"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default AppModalFilePreview